import {
  Checkbox,
  CheckboxGroup,
  Column,
  Columns,
  FormHelperText,
  Heading,
  List,
  ListItem,
  Stack,
  Text,
  TextLink,
} from "@origin-digital/ods-core";
import React from "react";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";
import { AccountPayer, HandoverTypeEnum } from "../../types";

const CloseTransferImportantInfo: React.FC = () => {
  const { formikContext, formBehavior } = useCloseTransferFormProps();
  const { values, setFieldValue, errors } = formikContext;
  const { closeTransfer } = values;
  const { hasElectricitySection, hasGasSection, accountPayers } = formBehavior;
  const isOnlyOneServiceType = hasElectricitySection !== hasGasSection;
  return (
    <Stack
      space={{
        xs: "large",
        md: "xlarge",
      }}
    >
      <Heading variant="h4">Important information</Heading>

      <Columns
        collapseBelow="md"
        space={{
          xs: "none",
          md: "xlarge",
        }}
        alignY="stretch"
      >
        {/* Fields */}
        <Column width="2/3">
          <Stack space="large">
            <List space="small">
              <ListItem>
                Disconnection can happen anytime from 7am on the requested date.
              </ListItem>
              <ListItem>
                You’ve confirmed access to your meter is clear, so you won’t
                have to be on-site.
              </ListItem>
              {isOnlyOneServiceType ? (
                <ListItem>
                  If the distributor can't read the meter remotely, a fee of up
                  to {hasGasSection ? "$68.00" : "$126.29"} GST incl. may apply.
                </ListItem>
              ) : (
                <ListItem>
                  If the distributor can't read the meter remotely, for
                  electricity a fee of up to $126.29 GST incl. and for gas a fee
                  of up to $68.00 GST incl. may apply.
                </ListItem>
              )}
              <ListItem>
                Fees vary depending on who your distributor is.{" "}
                <TextLink
                  href="https://www.originenergy.com.au/for-home/electricity-and-gas/info/find-my-distributor/"
                  target="_blank"
                >
                  Find your distributor
                </TextLink>{" "}
                and look up the exact fees online.
              </ListItem>
            </List>

            {(accountPayers.includes(AccountPayer.SOMEONE_ELSE) ||
              values.closeTransfer?.isShowCustomerConsentCheckbox) &&
              values.closeTransfer?.handoverType ===
                HandoverTypeEnum.CLOSE_AND_TRANSFER && (
                <CheckboxGroup id="checkbox">
                  <Checkbox
                    id="customer-consent"
                    checked={closeTransfer.isCustomerConsentChecked}
                    label={
                      <Text>
                        I have let the customer know that their information has
                        been provided to Origin and told them about Origin’s{" "}
                        <TextLink
                          href="http://www.originenergy.com.au/privacy"
                          target="_blank"
                        >
                          privacy and credit reporting statements
                        </TextLink>
                        .
                      </Text>
                    }
                    onChange={(event) =>
                      setFieldValue(
                        "closeTransfer.isCustomerConsentChecked",
                        event.target.checked
                      )
                    }
                    error={Boolean(
                      errors.closeTransfer?.isCustomerConsentChecked
                    )}
                  />
                  {errors.closeTransfer?.isCustomerConsentChecked && (
                    <FormHelperText id="customer-consent-error" error>
                      Oops, you must confirm that you have informed the
                      customer.
                    </FormHelperText>
                  )}
                </CheckboxGroup>
              )}
          </Stack>
        </Column>
        {/* Fields */}
        {/* HelperText */}
        <Column width="1/3" />
        {/* End HelperText */}
      </Columns>
    </Stack>
  );
};
export default CloseTransferImportantInfo;
